<template>
  <div>
    <v-alert color="warning">
      <div style="color: white; font-weight: bold">
        နေ့စဉ် Refresh ပြုလုပ်နိုင်သည့်အရေအတွက် ကုန်သွားပါပြီ
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "DailyRefreshAlert",
  data() {
    return {};
  },
};
</script>